import $, { post } from 'jquery';

const debug = false;
if (debug) {
    console.log('Debugging is enabled');
}

let headerHeight = $('.site-header').outerHeight();
let tabNavHeight = $('.tab-navigation').outerHeight();
function stickyElementSetup() {
    headerHeight = $('.site-header').outerHeight();
    $('.sticky-header-placeholder').css('height', headerHeight);
    if ($('.tab-navigation').length) {
        tabNavHeight = $('.tab-navigation').outerHeight();
        $('.sticky-nav-placeholder').css('height', tabNavHeight);
    }
}



function loadFullSearchResults(event, post_type) {
    if (debug) {
        console.log(event);
    }
    $("#post_type_filter_tag_" + post_type).trigger('click');
    if (debug) {
        console.log('Loading full search results for post type: ' + post_type, $("#post_type_filter_tag_" + post_type));
    }
    return false;
}

window.loadFullSearchResults = loadFullSearchResults;

$(window).on('resize', function() {
    stickyElementSetup();
});

$(() => {

    $('body').on('click', '.archive-wrapper .search-more a', function(e) {
        let post_type = $(this).attr('data-post-type');
        let category = $(this).attr('data-category');
        if (debug) {
            console.log('Search more clicked for post type: ' + post_type + ' and category: ' + category);
        }
        //uncheck everything except the post type and category
        $('.filter-item input[type="checkbox"]').prop('checked', false);
        $('.filter-item input[type="checkbox"]:not(:checked)').each(function() {
            if (debug) {
                console.log($(this));
            }
            if (typeof(category) != 'undefined' && category != '') {

            } else {
                if ($(this).val() == post_type) {
                    $(this).trigger('click');
                }
            }
        });
        e.preventDefault();
    });

    stickyElementSetup();

    //sticky header calculation
    
    let lastScrollTop = 0;
    let scrollUptolerence = 15;
    let scrollDowntolerence = 12;
    $(window).on('scroll', function() {
        let scrollTop = $(this).scrollTop();

        if (scrollTop > headerHeight) {
            $('body').removeClass('sticky-header-absolute');
            $('body').addClass('sticky-header-shadow');
            if (scrollTop > lastScrollTop + scrollDowntolerence) {
                //scroll down
                $('body').removeClass('sticky-header-visible');
            }
            if (scrollTop < lastScrollTop - scrollUptolerence) {
                //scroll up
                $('body').addClass('sticky-header');
                window.setTimeout(function() {
                    $('body').addClass('sticky-header-visible');
                }, 20);
            }
        } else {
            //if the scroll is less than the header height, remove the sticky class
            $('body').removeClass('sticky-header').addClass('no-transition');
            $('body').addClass('sticky-header-visible');
            $('body').addClass('sticky-header-absolute');
            $('body').removeClass('sticky-header-shadow');
            window.setTimeout(function() {
                $('body').removeClass('no-transition');
            }, 10);
        }
        
        //update the last scroll top if we are not within the tolerence
        if (Math.abs(scrollTop - lastScrollTop) > scrollUptolerence) {
            lastScrollTop = scrollTop;
        }

        if ($('.admin-bar').length && window.innerWidth > 782) {
            scrollTop = scrollTop + $('#wpadminbar').outerHeight();
        }

        if ($('.tab-navigation').length) {
            var offset = $('.tab-navigation').offset().top;
            if (scrollTop > offset && !$('.tab-navigation').hasClass('sticky')) {
                $('.tab-navigation').addClass('sticky');
            } else {
                if ($('.sticky-nav-placeholder').length) {
                    if (scrollTop <= $('.sticky-nav-placeholder').offset().top) {
                        $('.tab-navigation').removeClass('sticky');
                    }
                }
            }
        }
    });

    $(window).on('resize', () => {
        $('body').addClass('no-transition').delay(10).queue(() => {
            $('body').removeClass('no-transition').dequeue();
        });
    });

    $('.footer-navigation div[class^="menu-"][class*="-container"] > ul > li > a').on('click', function(e) {
        if ($(this).parent().hasClass('menu-item-has-children')) {
            e.preventDefault();
            //remove active class for all other items
            $(this).parent().siblings().removeClass('active');
            $(this).parent().toggleClass('active');   
        }
    });

    if (debug) {
        document.body.addEventListener('htmx:beforeRequest', (e) => {
            console.log('Before request:', e.detail.elt, e.detail.path);
        });
        document.body.addEventListener('htmx:afterRequest', (e) => {
            console.log('After request:', e.detail.elt, e.detail.xhr.status);
        });
        document.body.addEventListener('htmx:responseError', (e) => {
            console.error('HTMX Response Error:', e.detail.xhr.status);
        });
    }

    let _htmx_pending = false;

    function populate_search_archive_group(target, selected_post_types) {
        if (debug) {
            console.log('populate_search_archive_group called with target:', target, 'and selected_post_types:', selected_post_types);
        }
        if (!_htmx_pending) {
            _htmx_pending = true;
            let post_type = target.attr('data-post-type');
            let url_params = '?search_term=' + $('#search-input').val();
            if (debug) {
                console.log('Sending HTMX Request to: ' + $('#rest_endpoint').val() + post_type + '/' + url_params);
            }
            let html_target = target.find('.archive-list')[0];
            //send the HTMX request

            let args = {}

            if (selected_post_types && Object.keys(selected_post_types).length == 1) {
                //remove the 'search-more' element
                target.find('.search-more').addClass('inactive');
                target.after('<div id="pagination"></div>');
                args = {
                    target: html_target,
                    swap: 'outerHTML show:.archive-content:top',
                    values: {
                        page: 1,
                        full_results: 1
                    }                    
                }
            } else {
                target.find('.search-more').removeClass('inactive');
                $('#pagination').remove();
                args = {
                    target: html_target,
                    swap: 'outerHTML show:.archive-content:top',
                };
            }

            if (typeof htmx.ajax === 'function') {

                if (args.target) {
                    htmx.ajax('GET', $('#rest_endpoint').val() + post_type + '/' + url_params, args)
                    .then(() => {
                        if (debug) {
                            console.log('HTMX Request Complete for post type: ' + post_type);
                        }
                        _htmx_pending = false;
                    })
                }

            } else {
                if (debug) {
                    console.error('htmx.ajax is not defined');
                }
            }
        }
    }

    function populate_archive_group(target, selected_taxonomies) {
        if (!_htmx_pending) {
            _htmx_pending = true;
            let selected_taxonomies_category = [];
            let software_category = target.attr('data-software_category');
            let url_params = '';
            let post_type = target.attr('data-post-type');

            if (software_category) {
                if (!selected_taxonomies_category['software_category']) {
                    selected_taxonomies_category['software_category'] = [];
                }
                if (!selected_taxonomies_category['software_category'].includes(software_category)) {
                    selected_taxonomies_category['software_category'].push(software_category);
                }

                //merge selected_taxonomies into selected_taxonomies_category
                for (var key in selected_taxonomies) {
                    if (selected_taxonomies.hasOwnProperty(key)) {
                        if (!selected_taxonomies_category[key]) {
                            selected_taxonomies_category[key] = [];
                        }
                        for (var i = 0; i < selected_taxonomies[key].length; i++) {
                            if (!selected_taxonomies_category[key].includes(selected_taxonomies[key][i])) {
                                selected_taxonomies_category[key].push(selected_taxonomies[key][i]);
                            }
                        }
                    }
                }
            } else {
                selected_taxonomies_category = selected_taxonomies;
            }

            for (var key in selected_taxonomies_category) {
                if (selected_taxonomies_category.hasOwnProperty(key)) {
                    if (url_params.length > 0) {
                        url_params += '::' + key;
                    } else {
                        url_params = key;
                    }
                }
            }

            let tax_terms = '';
            for (var key in selected_taxonomies_category) {
                let _this_terms = '';
                if (selected_taxonomies_category.hasOwnProperty(key)) {
                    //loop through the array and append to url_params
                    for (var i = 0; i < selected_taxonomies_category[key].length; i++) {
                        if (_this_terms.length > 0) {
                            _this_terms += '|' + selected_taxonomies_category[key][i];
                        } else {
                            _this_terms = selected_taxonomies_category[key][i];
                        }
                    }
                }
                tax_terms += (tax_terms ? '::' : '') + _this_terms;
                if (i < selected_taxonomies_category[key].length - 1) {
                    tax_terms += '::';
                }
            }
            url_params += '/' + tax_terms;


            if (debug) {
                console.log('Sending HTMX Request to: ' + $('#rest_endpoint').val() + '/' + url_params);
            }

            let html_target = '.archive-list';

            if (software_category) {
                html_target = '#group_' + software_category;
            }

            let rest_base = $('#rest_endpoint').val();

            if (post_type) {
                rest_base += post_type;
                if (debug) {
                    console.log('Post type: ' + post_type, rest_base);
                }
                html_target = '#post_type-' + post_type;
            }

            htmx.ajax('GET', rest_base + '/' + url_params, {
                target: html_target, 
                swap:'outerHTML show:.archive-content:top', 
                values: {
                    page: 1,
                    archived: $('#archived').val(),
                    search: (post_type ? 1 : 0)
                }
            }).then(() => {
                _htmx_pending = false;
                if (debug) {
                    console.log('HTMX Request Complete');
                }
            });
        }
    }

    function begin_populate_search_archive_group(target, selected_post_types, selected_archive_groups, index) {
        if (target && selected_post_types) {
            if (debug) {
                console.log('begin_populate_search_archive_group called with target:', target, 'and selected_post_types:', selected_post_types);
            }
            populate_search_archive_group(target, selected_post_types);
        } else {
            return;
        }
        index = index || 0;
        window.setTimeout(function() {
            if (index < selected_archive_groups.length - 1) {
                index++;
                target = selected_archive_groups[index];
                if (target.length > 0) {
                    begin_populate_search_archive_group(target, selected_post_types, selected_archive_groups, index);
                }
            }
        }, 100);
    }

    function begin_populate_archive_group(target, selected_taxonomies, index) {
        populate_archive_group(target, selected_taxonomies);
        window.setTimeout(function() {
            if (index < $('.archive-group').length - 1) {
                index++;
                target = $('.archive-group').eq(index);
                if (target.length > 0) {
                    begin_populate_archive_group(target, selected_taxonomies, index);
                }
            }
        }, 100);
    }

    function updateDropdownFilters(target) {
        if (debug) {
            console.log('updateDropdownFilters');
        }

        var selected_taxonomies = [];
        var selected_post_types = [];

        var selected = target.find('.filter-dropdown input[type="checkbox"]:checked');

        $('.active-filters span').html(selected.length);

        selected.each(function() {
            var taxonomy = $(this).attr('data-taxonomy');
            if (taxonomy && taxonomy != 'post_type') {
                //check if the key exists in the array
                if (!selected_taxonomies[taxonomy]) {
                    selected_taxonomies[taxonomy] = [];
                }
                if (!selected_taxonomies[taxonomy].includes($(this).val())) {
                    selected_taxonomies[taxonomy].push($(this).val());
                }
            } else if (taxonomy == 'post_type') {
                if (!selected_post_types[$(this).val()]) {
                    selected_post_types[$(this).val()] = [];
                }
                if ($(this).attr('data-category')) {
                    if (!selected_post_types[$(this).val()].includes($(this).attr('data-category'))) {
                        selected_post_types[$(this).val()].push($(this).attr('data-category'));
                    }
                }
            }
        });

        if (debug) {
            console.log('Selected taxonomies: ', selected_taxonomies);
            console.log('Selected post types: ', selected_post_types);
        }

        //check if we have any object keys in the selected_post_types array
        if (Object.keys(selected_post_types).length > 0) {
            if (debug) {
                console.log('keys exist');
                console.log('Selected post types: ', selected_post_types);
            }
        }

        $('.archive-group').removeClass('active-search-group inactive-search-group');

        if (Object.keys(selected_post_types).length > 0) {
            var selected_archive_groups = [];

            // loop through the selected post types and get the archive groups
            for (var key in selected_post_types) {
                if (selected_post_types.hasOwnProperty(key)) {
                    //check if key has an array
                    if (selected_post_types[key].length > 0) {
                        //loop through the array and get the archive groups
                        for (var i = 0; i < selected_post_types[key].length; i++) {
                            if ($('.archive-group[data-post-type="' + key + '"][data-category="' + selected_post_types[key][i] + '"]').length > 0) {
                                selected_archive_groups.push($('.archive-group[data-post-type="' + key + '"][data-category="' + selected_post_types[key][i] + '"]'));
                                $('.archive-group[data-post-type="' + key + '"][data-category="' + selected_post_types[key][i] + '"]').addClass('active-search-group');
                            }
                        }
                    } else {
                        if ($('.archive-group[data-post-type="' + key + '"]').length > 0) {
                            selected_archive_groups.push($('.archive-group[data-post-type="' + key + '"]'));
                            $('.archive-group[data-post-type="' + key + '"]').addClass('active-search-group');
                        }
                    }
                }
            }

            if (debug) {
                console.log('Selected archive groups: ', selected_archive_groups);
            }
            if (selected_archive_groups.length > 0) {
                var current_archive_group_index = 0;
                target = selected_archive_groups[current_archive_group_index];
                if (current_archive_group_index < selected_archive_groups.length) {
                    begin_populate_search_archive_group(target, selected_post_types, selected_archive_groups, current_archive_group_index);
                }
            }
            $('.archive-group').not('.active-search-group').addClass('inactive-search-group'); 
        } else {
            if ($('.archive-group').length > 1) {
                var current_archive_group_index = 0;
                target = $('.archive-group').eq(current_archive_group_index);
                if (current_archive_group_index < $('.archive-group').length) {
                    if ($('.search-archive').length) {
                        begin_populate_search_archive_group(target, selected_post_types, selected_archive_groups, current_archive_group_index);
                    } else {
                        begin_populate_archive_group(target, selected_taxonomies, current_archive_group_index);
                    }
                }

            } else {
                populate_archive_group($(this), selected_taxonomies);
            }

        }

    }

    $('body').on('click', '.dropdown-filters .filter-reset-toggle a', function(e) {
        var _this = $(this).parents('.dropdown-filters');
        if (_this.find('.filter-dropdown .mobile-actions').is(':visible')) {
            //mobile functionality
            _this.toggleClass('active');
        } else {
            //desktop functionality
            _this.find('input[type="checkbox"]').prop('checked', false);
            updateDropdownFilters(_this);
        }
        e.preventDefault();
    });

    $('body').on('change', '.dropdown-filters .filter-dropdown input[type="checkbox"]', function() {
        var _this = $(this).parents('.dropdown-filters');

        var current_state = $(this).prop('checked');

        if (!_this.find('.filter-dropdown .mobile-actions').is(':visible')) {
            if (!_htmx_pending) {
                updateDropdownFilters(_this);
            } else {
                //restore the checkbox to its previous state
                $(this).prop('checked', !current_state);
            }
        }
    });

    $('body').on('click', '.dropdown-filters .filter-dropdown .mobile-actions .btn-primary', function(e) {
        var _this = $(this).parents('.dropdown-filters');
        updateDropdownFilters(_this);
        _this.toggleClass('active');
        e.preventDefault();
    });

    $('body').on('click', '.dropdown-filters .filter-dropdown .mobile-actions .btn-secondary', function(e) {
        var _this = $(this).parents('.dropdown-filters');
        _this.find('input[type="checkbox"]').prop('checked', false);
        updateDropdownFilters(_this);
        _this.toggleClass('active');
        e.preventDefault();
    });

    $('body').on('click', '.information-panel .close-panel a', function(e) {
        $(this).parents('.information-panel').parent().removeClass('active');
        //set local storage
        localStorage.setItem('information-panel', 'closed');
        //set a date the user closed the panel
        localStorage.setItem('information-panel-closed', new Date().getTime());
        e.preventDefault();
    });

    $('.faq-item a').on('click', function(e) {
        //remove active class for all other items
        $(this).parent().siblings().removeClass('active');
        $(this).parent().toggleClass('active');
        e.preventDefault();
    });

    $('.wp-block-table table').each(function() {
        //get the thead column names
        var columns = [];
        $(this).find('thead th').each(function() {
            columns.push($(this).text());
        });
        //skip the first column of each row, but append the column name to the column as a data attribute
        $(this).find('tbody tr').each(function() {
            $(this).find('td').each(function(i) {
                $(this).attr('data-column', columns[i]);
            });
        });
    });

    $('.wp-block-video video:not([autoplay])').on('click', function() {
        if ($(this).get(0).paused) {
            $(this).get(0).play();
            $(this).attr('playing', 'true');
        } else {
            $(this).get(0).pause();
            $(this).removeAttr('playing');
        }
    });

    $('.event-signup-jump-button').on('click', function(e) {
        var target = $('.event-signup-form_wrapper');
        var offset = target.offset().top - ($('#wpadminbar').length ? 56 : 32);
        $('html, body').animate({
            scrollTop: offset
        }, 500);
        e.preventDefault();
    });

    var sliding = false;

    $('.wp-block-gallery').each(function() {
        //add navigation to the gallery
        var gallery = $(this);
        gallery.find('.wp-block-image:first-child').addClass('active');
        var prev = $('<a href="#" class="gallery-nav prev">Previous</a>');
        var next = $('<a href="#" class="gallery-nav next">Next</a>');
        var nav = $('<div class="gallery-nav-container"></div>');
        nav.append(prev);
        nav.append(next);
        gallery.append(nav);
        gallery.find('.wp-block-image').addClass('no-transition');
        window.setTimeout(function() {
            gallery.find('.wp-block-image').removeClass('no-transition');
        }, 400);
        prev.on('click', function(e) {
            if (sliding) {
                e.preventDefault();
                return;
            }
            sliding = true;
            var current = gallery.find('.wp-block-image.active');
            var prev = current.prev();
            if (prev.length === 0) {
                prev = nav.prev();
                prev.addClass('prev').addClass('no-transition');
                window.setTimeout(function() {
                    prev.removeClass('no-transition');
                }, 10);
                
            }
            current.removeClass('active');
            window.setTimeout(function() {
                prev.addClass('active').removeClass('prev');
            }, 10);
            window.setTimeout(function() {
                sliding = false;
            }, 410);
            e.preventDefault();
        });
        next.on('click', function(e) {
            if (sliding) {
                e.preventDefault();
                return;
            }
            sliding = true;
            var current = gallery.find('.wp-block-image.active');
            current.addClass('prev');
            window.setTimeout(function() {
                current.removeClass('prev');
            }, 400);
            var next = current.next('.wp-block-image');
            if (next.length === 0) {
                next = gallery.find('.wp-block-image:first-child');
            }
            current.removeClass('active');
            window.setTimeout(function() {
                next.addClass('active');
            }, 10);
            window.setTimeout(function() {
                sliding = false;
            }, 410);
            e.preventDefault();
        });
        $(window).on('resize', function() {
            gallery.find('.wp-block-image').each(function() {
                $(this).addClass('no-transition');
                let _this = $(this);
                window.setTimeout(function() {
                    _this.removeClass('no-transition');
                }, 400);
            });
        });
    });

    if ($('.tab-groups').length) {

        $('.tab-groups a.active_tab').text(
            $('.tab-groups .tab-nav-content .dropdown ul li:first-child a').text()
        );

        $('.tab-groups a.active_tab').on('click', function(e) {
            $(this).parent().toggleClass('active');
            e.preventDefault();
        });

        $('.tab-groups').on('click', '.tab-nav-content .dropdown ul li a', function(e) {
            $(this).parents('.tab-groups').find('.tab-group').removeClass('active');
            $(this).parents('.tab-groups').find('.tab-group').eq($(this).parent().index()).addClass('active');
            $(this).parents('.tab-groups').find('a.active_tab').text($(this).text());
            $(this).parents('.tab-groups').find('.tab-nav-content').removeClass('active');
            var offset = $(this).parents('.tab-groups').find('.tab-group.active').offset().top - ($('#wpadminbar').length ? 32 : 0);
            $('html, body').animate({
                scrollTop: offset
            }, 500);
            e.preventDefault();
        });

    }

    $('.wp-block-button.back-to-top-button a').on('click', function(e) {
        $('html, body').animate({
            scrollTop: 0
        }, 500);
        e.preventDefault();
    });

    $('a.wp-block-button__link').on('click', function(e) {
        var target = $(this).attr('href');
        if (target && target.startsWith('#')) {

            //check the '.tab-groups' links and see if any of the links are the same, if so trigger the click event
            if ($('.tab-groups').length) {
                var tabGroups = $('.tab-groups .tab-navigation a[href="' + target + '"]');
                if (tabGroups.length) {
                    tabGroups.trigger('click');
                    e.preventDefault();
                }
            }
        }
    });

    $('#update-account-details-btn').on('click', function(e) {
        e.preventDefault();
        $('.modal-form-wrapper.update-account-details').addClass('active');
    });

    $('#scriptbox-upload-btn').on('click', function(e) {
        e.preventDefault();
        $('.modal-form-wrapper.upload-script').addClass('active');
        // scriptUploadObserver.enable();
    });

    $('.login-register-button').on('click', function(e) {
        e.preventDefault();
        $('.modal-form-wrapper.login-register').addClass('active');
    });

    $('.forgot-password-link').on('click', function(e) {
        e.preventDefault();
        $('.modal-form-wrapper.forgot-password').addClass('active');
        // scriptUploadObserver.enable();
    });

    $('.modal-close a').on('click', function(e) {
        e.preventDefault();
        $(this).parents('.modal-form-wrapper').removeClass('active');
        // scriptUploadObserver.disable();
    });

    $('.request-software-version-button a').on('click', function(e) {
        e.preventDefault();
        $('.modal-form-wrapper.request-download-version').addClass('active');
        // scriptUploadObserver.enable();
    });

    if ($('.gform_validation_error').length) {
        $('.gform_validation_error').parents('.modal-form-wrapper').addClass('active');
        // scriptUploadObserver.enable();
    }

    //keybind escape to close the modal if open
    $(document).on('keydown', function(e) {
        if (e.key === "Escape") {
            if ($('.modal-form-wrapper').hasClass('active')) {

                if ($('.modal-form-wrapper.small').hasClass('active')) {
                    e.preventDefault();
                    $('.modal-form-wrapper.small').removeClass('active');
                } else {
                    e.preventDefault();
                    $('.modal-form-wrapper').removeClass('active');
                    // scriptUploadObserver.disable();
                }
            }
        }
    });

    $('.modal-form-wrapper.update-account-details form.acfe-form input[type=submit]').on('click', function(e) {
        $('.modal-form-wrapper.confirm-password .acf-notice').remove();
        if ($('.modal-form-wrapper.confirm-password').hasClass('active') || $('.modal-form-wrapper.update-account-details').hasClass('password-confirmed')) {
            if ($('.modal-form-wrapper.update-account-details').hasClass('password-confirmed')) {
                $('.modal-form-wrapper.confirm-password').removeClass('active');
                //reset the password field
                $('input[name=current_user_password]').val('');
            } else {
                //ajax call to check user password
                $.ajax({
                    url: ajax_object.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'check_user_password',
                        password: $('input[name=current_user_password]').val()
                    },
                    success: function(result) {
                        if (debug) {
                            console.log(result);
                        }
                        if (result.success == true) {
                            $('.modal-form-wrapper.update-account-details').addClass('password-confirmed');
                            window.setTimeout(function() {
                                $('.modal-form-wrapper.update-account-details form.acfe-form input[type=submit]').trigger('click');
                            }, 100);
                        } else {
                            $('.modal-form-wrapper.confirm-password .acf-input').prepend('<div class="acf-notice -error acf-error-message"><p>Incorrect password</p></div>');
                            //shake the form
                            var tl = gsap.timeline();
                            tl.to('.modal-form-wrapper.confirm-password .modal-form-container', {
                                x: 20,
                                duration: 0.1
                            });
                            tl.to('.modal-form-wrapper.confirm-password .modal-form-container', {
                                x: -20,
                                duration: 0.1
                            });
                            tl.to('.modal-form-wrapper.confirm-password .modal-form-container', {
                                x: 0,
                                duration: 0.1
                            });
                        }
                    }
                });
                e.preventDefault();
                e.stopPropagation();
            }
        } else {
            $('.modal-form-wrapper.confirm-password').addClass('active');
            e.preventDefault();
            e.stopPropagation();
        }
    });

    $('.modal-form-wrapper.confirm-password .acf-input input').on('keyup', function(e) {
        if ($(this).val().length > 0) {
            $('.modal-form-wrapper.confirm-password .acf-notice').remove();
        }
    });

    $('.modal-form-wrapper.confirm-password form.acfe-form input[type=submit]').on('click', function(e) {
        $('.modal-form-wrapper.update-account-details form.acfe-form input[type=submit]').trigger('click');
        e.preventDefault();
        e.stopPropagation();
    });

    $('.current-password-field').hide();
    $('input[name=current_user_password]').on('keyup', function(e) {
        //copy the value to the confirm password field
        $('.current-password-field input').val($(this).val());
    });

    if ($('.wp-block-notification').length) {
        //remove /?update=success from the url
        if (window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.delete('update');
            url.searchParams.delete('reset');
            url.searchParams.delete('password-change');
            url.searchParams.delete('scriptbox_upload');
            window.history.replaceState({}, document.title, url);
        }
        $('.wp-block-notification').each(function() {
            setTimeout(() => {
                $(this).slideUp(300, function() {
                    $(this).remove();
                });
            }, 8000);
        });
    }

    $('.request-software-version-button').on('click', function(e) {
        e.preventDefault();
    });

    $('.edit-script-button').on('click', function(e) {
        $('.modal-form-wrapper.upload-script').addClass('active');
        e.preventDefault();
    });

    $('.delete-script-button').on('click', function(e) {
        var script_id = $(this).attr('data-script-id');
        if (debug) {
            console.log('Delete script button clicked for script ID:', script_id);
        }
        var r = confirm('Are you sure you want to delete this script? This action cannot be undone.');
        if (r == true) {
            //ajax call to delete the script
            $.ajax({
                url: ajax_object.ajax_url,
                type: 'POST',
                data: {
                    action: 'delete_script',
                    script_id: script_id
                },
                success: function(result) {
                    window.location.href = result.data.url;
                },
                error: function(xhr, status, error) {
                    if (debug) {
                        console.error('Error deleting script:', error);
                    }
                }
            });
        }
        e.preventDefault();
    });

});

function onFileSelected (evt) {
	const fileInput = evt.target;
    const files = Array.from(evt.target.files).map(file => file.name);
    const placeholder = fileInput.getAttribute('data-placeholder') ||  fileInput.placeholder;
  
    // Store original placeholder
    fileInput.setAttribute('data-placeholder', placeholder);
 
    // Update current placeholder
    if (files.length === 1) {
        fileInput.placeholder = files[0].replace(/.*[\/\\]/, '');
        fileInput.classList.add('selected');
    } else if (files.length > 1) {
 		fileInput.placeholder = `${files.length} files`;
        fileInput.classList.add('selected');
 	} else {
   	    fileInput.placeholder = placeholder;
        fileInput.classList.remove('selected');
 	}
}

document.querySelectorAll('input[type="file"]').forEach(el =>
	el.addEventListener('change', onFileSelected)
);

//check for notification messages using ajax
$.ajax({
    url: ajax_object.ajax_url,
    type: 'POST',
    data: {
        action: 'get_notification_messages'
    },
    success: function(result) {
        if (result.data.length == 0) {
            return;
        }

        var date = new Date(result.data[0].visible_from);
        var user_dimissed = localStorage.getItem('information-panel-closed');

        if (!user_dimissed || date.getTime() > user_dimissed) {
            //append the notification message to the 'site-header' in position 1
            var notification = '<div class="information-panel"><div class="content">' + result.data[0].message + '</div><div class="close-panel"><a href="#">Close</a></div></div>';
            $('#page > .site-header').prepend(notification);
            $('#page > .site-header').addClass('has-notification active');
        }
    }
});

if ($('.scriptbox-actions-panel').length) {
    //ajax call to get users name
    $.ajax({
        url: ajax_object.ajax_url,
        type: 'POST',
        data: {
            action: 'get_user_name'
        },
        success: function(result) {
            if (result.success) {
                if (debug) {
                    console.log(result);
                }
                $('.current_user_display_name').text(result.data.name);
            }
        }
    });
}

if ($('.modal-form-wrapper.update-account-details').length) {
    //ajax call to get users account data
    $.ajax({
        url: ajax_object.ajax_url,
        type: 'POST',
        data: {
            action: 'get_user_account_details'
        },
        success: function(result) {
            if (result.success) {
                if (debug) {
                    console.log(result);
                }
                //set the values of the form inputs
                $('.modal-form-wrapper.update-account-details .acf-field[data-name="first_name"] input').val(result.data.first_name);
                $('.modal-form-wrapper.update-account-details .acf-field[data-name="last_name"] input').val(result.data.last_name);
                $('.modal-form-wrapper.update-account-details .acf-field[data-name="email_address"] input').val(result.data.email);
                $('.modal-form-wrapper.update-account-details .acf-field[data-name="company_name"] input').val(result.data.company_name);
            }
        }
    });
}
